
import { useState, useEffect } from 'react';
import HeroSection from './components/HeroSection';
import StartPage from './components/StartPage';
import RoboticsHome from './RoboticsHome';
import RoboticsServices from './RoboticsServices';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import RoboticsAboutUs from './RoboticsAboutUs';
import RoboticsUseCase from './RoboticsUseCase';
import RoboticsContact from './roboticsContact';
import RoboticsTeam from './RoboticsTeam';
import RoboticsProduct from './RoboticsProducts';
import HorecaHome from './HorecaHome';
import HorecaAboutUs from './HorecaAboutUs';
import HorecaContact from './HorecaContact';
import HorecaProduct from './HorecaProducts';

function App() {
  const [showStart, setShowStart] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowStart(false);
    }, 1000);

    // Cleanup timer if the component is unmounted
    return () => clearTimeout(timer);
  }, []);

return(
<Router>
      <Routes>
        <Route path="/" element={showStart ? <StartPage /> : <HeroSection/>} />
        <Route path="/Robotics-Home" element={<RoboticsHome/>} />
        <Route path="/Robotics-AboutUs" element={<RoboticsAboutUs/>} />
        <Route path="/Robotics-Services" element={<RoboticsServices/>} />
        <Route path="/Robotics-Usecase" element={<RoboticsUseCase/>} />
        <Route path="/Robotics-Contact" element={<RoboticsContact/>} />
        <Route path="/Robotics-Team" element={<RoboticsTeam/>} />
        <Route path="/Robotics-Products" element={<RoboticsProduct/>} />
        <Route path="/Horeca-Home" element={<HorecaHome/>} />
        <Route path="/Horeca-AboutUs" element={<HorecaAboutUs/>} />
        <Route path="/Horeca-Contact" element={<HorecaContact/>} />
        <Route path="/Horeca-Products" element={<HorecaProduct/>} />
        
        
        
      </Routes>
    </Router>);

}

export default App;
